module.exports = function getResource(label, vars = []) {
    let resources = {
        reviewsLabel: `${vars[0]}`,
        writeReview: 'Write a review'
    };
    return resources[label];
};
